export default __webpack_public_path__ + "static/media/RiskMatics.2dd1d4fc059822677b1d5fa18b5b2461.webp";